import { type AppState, Auth0Provider } from '@auth0/auth0-react'
import { useRouter } from 'next/navigation'
import React, { createContext, type RefObject, useMemo, useRef } from 'react'
import ENV_VARS from 'src/global/environmentVariables'

import { APP_PATHS } from '@/global/consts'

interface Auth0ProviderWithHistoryProps {
  children: React.ReactNode
}

export const AuthRedirectContext = createContext<{
  redirectUrl: RefObject<string>
} | null>(null)

export const Auth0ProviderWithHistory: React.FC<Auth0ProviderWithHistoryProps> = ({ children }) => {
  const router = useRouter()
  const redirectUrl = useRef<string>(APP_PATHS.DEFAULT)
  const onRedirectCallback = (appState: AppState | undefined) => {
    redirectUrl.current = appState?.returnTo || window.location.pathname
    router.push(redirectUrl.current)
  }
  const redirectContext = useMemo(() => ({ redirectUrl }), [redirectUrl])

  return (
    <Auth0Provider
      domain={ENV_VARS.AUTH_DOMAIN!}
      clientId={ENV_VARS.AUTH_CLIENT_ID!}
      onRedirectCallback={onRedirectCallback}
      useRefreshTokens={true}
      cacheLocation="localstorage"
      cookieDomain={ENV_VARS.COOKIE_DOMAIN}
      authorizationParams={{
        audience: ENV_VARS.AUTH_API_AUDIENCE,
        redirect_uri: ENV_VARS.BASE_URL,
      }}
    >
      <AuthRedirectContext.Provider value={redirectContext}>
        {children}
      </AuthRedirectContext.Provider>
    </Auth0Provider>
  )
}
